import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import config from "../config/config";
import { useSiteContext } from "../contexts/SiteProvider";
import { setSessionStorage } from "../services/sessionService";
interface PrivateRouteProps {
  children: ReactNode; // children is ReactNode since it can be any valid JSX or element
  allowedRoles?: string[]; // assuming allowedRoles is an array of strings, can be optional if needed
}
const session_key = config.REDIRECT_SESSION_KEY||"session_key";
const PrivateRoute: React.FC<PrivateRouteProps> = React.memo(
  ({ children, allowedRoles }) => {
    const { user } = useSiteContext(); // assuming user comes from a context
    const location = useLocation();

    if (!user) {
      const currentPath = location.pathname;
      setSessionStorage(session_key, currentPath);
      // show alert for unauthorized access
     // showAlertAutoClose("Please Login", "error");
      // redirect to login page if user is not logged in
    //  return <Navigate to="/" />;
    }

    // if you need to check for roles before rendering the component
    setSessionStorage(session_key, "");
    return <>{children}</>;
  }
);

export default PrivateRoute;
